import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import ProductAttributeIcons from '../ProductAttributeIcons';
import { sortAttributesByOrder } from './AttributesFilter';

const attributeDisplayNames: Record<string, string> = {
  isContracted: 'Contracted Item',
  productInFavoriteFolder: 'In Favorite Folder',
  isOfflineSupplierItem: 'Offline Supplier Item',
  isImageAvailable: 'Picture Available',
  isSpecialOrder: 'Special Order - Item may incur additional shipping charges',
  isFormulary: 'Company Specified',
};

const AttributesCell = (props: GridCellProps) => {
  const field = props.field || '';
  const attributes: string[] = props.dataItem[field] || [];

  // Sort attributes according to ATTRIBUTE_ORDER
  const sortedAttributes = sortAttributesByOrder(attributes);

  const displayNames = sortedAttributes
    .map((attr) => attributeDisplayNames[attr] || attr)
    .join(', ');

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={displayNames}>
      <ProductAttributeIcons attributes={sortedAttributes} />
    </GridCellBase>
  );
};

export default AttributesCell;
